module.exports = __webpack_public_path__ + "img/CM-BS-24-GMC-Established.1ac68047.jpg";